import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, FormattedDate, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl'
import { toInteger, isEmpty, sortBy, reverse } from 'lodash'
import moment from 'moment'

import { callApi } from '../services/fetchService'
import { encodePatient, decodePatient } from '../services/encodingService'
import { getSelectOptions, getOptions } from '../services/selectService'
import { loadGlobals, openPatientRecord, openConsultation } from '../actions'

import Badge from '../components/Badge'
import FaIcon from '../components/FaIcon'
import { Row, Col, Card, Form, Input, Button, Divider, Select, Spin, List, Radio, DatePicker, message } from 'antd'
const FormItem = Form.Item
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;



/**
 * Patient form inside the view
 */

class _PatientForm extends Component {

    static propTypes = {
        patient: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        birthDate: null
    }

    componentWillMount() {
        this.setState({
            birthDate: this.props.patient.birthDate
        })
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginTop: '25px' }
        }

        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit}>
                <FormItem label={<FormattedMessage id="patient.sheet.firstName" />} {...formItemLayout}>
                    {getFieldDecorator('firstName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'patient.sheet.firstNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.lastName" />} {...formItemLayout}>
                    {getFieldDecorator('lastName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'patient.sheet.lastNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.gender" />} {...formItemLayout}>
                    {getFieldDecorator('gender', {
                        rules: [{required: true, message: intl.formatMessage({id: 'patient.sheet.genderRequired'})}]
                    })(<RadioGroup>
                        {getOptions('gender').map((option) => <RadioButton key={option.key} value={option.key}><FaIcon icon={option.data.icon} /></RadioButton>)}
                    </RadioGroup>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.birthDate" />} {...formItemLayout}>
                    {getFieldDecorator('birthDate', {
                        rules: [{required: true, message: intl.formatMessage({id: 'patient.sheet.birthDateRequired'})}]
                    })(<DatePicker format="L" style={{ width: '60%' }} placeholder="" onChange={(date) => this.setState({ birthDate: date })} />)}
                    {this.state.birthDate ? <span style={{ marginLeft: "25px" }}><FormattedMessage id="patient.sheet.age" values={{ age: moment().diff(this.state.birthDate, 'years') }} /></span> : null}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.job" />} {...formItemLayout}>
                    {getFieldDecorator('job')(<Input addonBefore={<FaIcon icon="briefcase" fixedWidth />} />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="patient.sheet.addressStreet" />} {...formItemLayout}>
                    {getFieldDecorator('addressStreet')(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.addressNumber" />} {...formItemLayout}>
                    {getFieldDecorator('addressNumber')(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.addressZip" />} {...formItemLayout}>
                    {getFieldDecorator('addressZip')(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.addressCity" />} {...formItemLayout}>
                    {getFieldDecorator('addressCity')(<Input/>)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="patient.sheet.mobile" />} {...formItemLayout}>
                    {getFieldDecorator('mobile')(<Input addonBefore={<FaIcon icon="mobile" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.phone" />} {...formItemLayout}>
                    {getFieldDecorator('phone')(<Input addonBefore={<FaIcon icon="phone" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.fax" />} {...formItemLayout}>
                    {getFieldDecorator('fax')(<Input addonBefore={<FaIcon icon="fax" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="patient.sheet.email" />} {...formItemLayout}>
                    {getFieldDecorator('email', {
                        rules: [ {type: 'email', message: intl.formatMessage({id: 'patient.sheet.wrongEmail'})} ]
                    })(<Input addonBefore={<FaIcon icon="envelope" fixedWidth />} />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="patient.sheet.mainPathology" />} {...formItemLayout}>
                    {getFieldDecorator('mainPathology')(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('pathology', this.props.patient.mainPathology)}
                    </Select>)}
                </FormItem>
                <Divider />
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                </FormItem>
            </Form>
        )
    }

}

const PatientForm = injectIntl(Form.create({
    mapPropsToFields(props) {
        return {
            firstName: Form.createFormField({value: props.patient.firstName}),
            lastName: Form.createFormField({value: props.patient.lastName}),
            gender: Form.createFormField({value: props.patient.gender}),
            birthDate: Form.createFormField({value: props.patient.birthDate}),
            job: Form.createFormField({value: props.patient.job}),
            addressStreet: Form.createFormField({value: props.patient.addressStreet}),
            addressNumber: Form.createFormField({value: props.patient.addressNumber}),
            addressZip: Form.createFormField({value: props.patient.addressZip}),
            addressCity: Form.createFormField({value: props.patient.addressCity}),
            mobile: Form.createFormField({value: props.patient.mobile}),
            phone: Form.createFormField({value: props.patient.phone}),
            fax: Form.createFormField({value: props.patient.fax}),
            email: Form.createFormField({value: props.patient.email}),
            mainPathology: Form.createFormField({value: props.patient.mainPathology})
       };
    }
})(_PatientForm))



/**
 * Patient view
 */

class PatientSheet extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        loadGlobals: PropTypes.func.isRequired,
        openPatientRecord: PropTypes.func.isRequired,
        openConsultation: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        patientId: null,
        patient: {},
        formPatient: {},
        consultations: [],
        loading: false,
        updating: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi([{
            endpoint: 'patients/' + this.state.patientId
        }, {
            endpoint: 'patients/' + this.state.patientId + '/consultations'
        }]).then((data) => {
            decodePatient(data[0]).then((decoded) => {
                data[0] = decoded
                data[0].birthDate = data[0].birthDate ? moment(data[0].birthDate) : null
                this.setState({
                    patient: data[0],
                    formPatient: Object.assign({}, data[0]),
                    consultations: reverse(sortBy(data[1], 'date')),
                    loading: false
                })
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = nextProps.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        if (this.state.patientId !== id) {
            this.setState({ patientId: id }, () => {
                if (this.isNew()) {
                    this.setState({ patient: {}, formPatient: {} })
                } else {
                    this.fetch()
                }
            })
        }
    }

    componentWillMount() {
        let id = this.props.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        this.setState({ patientId: id })
    }

    componentDidMount() {
        if (this.isNew()) {
            this.setState({ patient: {}, formPatient: {} })
        } else {
            this.fetch()
        }
    }

    savePatient = (patient) => {
        const { intl, history } = this.props
        this.setState({
            formPatient: Object.assign({}, this.state.formPatient, patient),
            updating: true
        })
        encodePatient(patient).then((encoded) => {
            // Insert new
            if (this.isNew()) {
                callApi({
                    endpoint: 'patients',
                    body: encoded,
                    method: 'PUT'
                }).then((data) => {
                    decodePatient(data).then((decoded) => {
                        data.birthDate = data.birthDate ? moment(data.birthDate) : null
                        this.setState({
                            patientId: data.id,
                            patient: data,
                            formPatient: Object.assign({}, data),
                            updating: false
                        })
                        message.success(this.props.intl.formatMessage({id: "misc.insertSuccess"}))
                        history.push('/patient/' + data.id)
                        this.props.loadGlobals()
                    })
                }).catch((err) => {
                    message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    this.setState({ updating: false })
                })
            }
            // Update
            else {
                callApi({
                    endpoint: 'patients/' + this.state.patientId,
                    body: encoded,
                    method: 'POST'
                }).then((data) => {
                    decodePatient(data).then((decoded) => {
                        data.birthDate = data.birthDate ? moment(data.birthDate) : null
                        this.setState({
                            patient: data,
                            formPatient: Object.assign({}, data),
                            updating: false
                        })
                        message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
                        this.props.loadGlobals()
                    })
                }).catch((err) => {
                    message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    this.setState({ updating: false })
                })
            }
        })
    }

    openPatientRecord = () => {
        this.props.openPatientRecord(this.state.patient)
    }

    openConsultation = (consultation) => {
        this.props.openConsultation(consultation)
        this.props.history.push('/patient/' + consultation.patient + '/observations')
    }

    isNew = () => {
        return this.state.patientId === null || this.state.patientId === undefined
    }

    render() {
        const { patient, loading, updating, formPatient, consultations } = this.state
      
		if (!this.isNew() && (isEmpty(patient) || loading)) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }
        
        return (
            <div>
                {
                    this.isNew() ? <h1><FaIcon icon="user" fixedWidth /><FormattedHTMLMessage id="patient.sheet.titleNew" /></h1>
                    : <h1><FaIcon icon="user" fixedWidth /> <FormattedHTMLMessage id="patient.sheet.titleUpdate" values={patient} /></h1>
                }
                { this.isNew() ? null : <div className="action-bar"><Button onClick={this.openPatientRecord}><FaIcon icon="folder-open"/> <FormattedMessage id="patient.sheet.openPatientRecord" /></Button></div> }
                <Row gutter={24}>
                    <Col lg={14}>
                        <Card title={<span><FaIcon icon="info-circle" /><FormattedMessage id="patient.sheet.identification" /></span>}>
                            <PatientForm patient={formPatient} onSubmit={this.savePatient} updating={updating} />
                        </Card>
                    </Col>
                    <Col lg={10}>
                        <Card title={<span><FaIcon icon="chart-bar" /><FormattedMessage id="patient.sheet.statistics" /></span>}>
                            <List itemLayout="horizontal" className="statistics">
                                <List.Item><FormattedMessage id="patient.sheet.numberOfConsultations" /><Badge>{this.isNew() ? '-' : patient.numberOfConsultations}</Badge></List.Item>
                                <List.Item><FormattedMessage id="patient.sheet.numberOfBloodTests" /><Badge>{this.isNew() ? '-' : patient.numberOfBloodTests}</Badge></List.Item>
                                <List.Item><FormattedMessage id="patient.sheet.firstConsultation" /><Badge>{patient.firstConsultation ? <FormattedDate value={patient.firstConsultation} /> : '-'}</Badge></List.Item>
                                <List.Item><FormattedMessage id="patient.sheet.lastConsultation" /><Badge>{patient.lastConsultation ? <FormattedDate value={patient.lastConsultation} /> : '-'}</Badge></List.Item>
                            </List>
                        </Card>
                        <Card title={<span><FaIcon icon="stethoscope" /><FormattedMessage id="patient.sheet.consultations" /></span>}>
                            <List itemLayout="horizontal" className="consultations-list" dataSource={consultations} renderItem={(item) => (
                                <List.Item onClick={() => this.openConsultation(item)}><FormattedDate value={item.date} /></List.Item>
                            )} />
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

}

export default injectIntl(withRouter(connect(null, {
    loadGlobals,
    openPatientRecord,
    openConsultation
})(PatientSheet)))


// WEBPACK FOOTER //
// ./src/views/PatientSheet.js